var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',[_c('b-tabs',{attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"title":"Profile","active":""}},[_c('FormUserProfile')],1),_c('b-tab',{attrs:{"title":"Change Password"}},[_c('FromChangePassword')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }